export const numToCurrency = (currency, numOfDecimal = 0) =>
    `Rs ${(currency ?? 0).toLocaleString('en-IN', { 
        maximumFractionDigits: numOfDecimal, 
        minimumFractionDigits: numOfDecimal 
    })}`;